export default {
  gzip: 'application/gzip',
  zip: 'application/zip',
  xml: 'application/xml',
  pdf: 'application/pdf',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  bmp: 'image/bmp',
  png: 'image/png',
  css: 'text/css',
  html: 'text/html'
};
